<template>
    <div class="integrity_search">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <div class="centerTab">
            <div><img src="../../assets/img/index/CXGheader.png" alt="" style="width: 100%;"></div>
            <div class="menuTab">
                <div class="top">
                    <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="input">
                        <el-input
                          placeholder="请输入查询关键字"
                          suffix-icon="el-icon-search"
                          v-model="input">
                        </el-input>
                        <el-button type="primary" @click="getList">搜索</el-button>
                    </div>
                    <div class="result">
                        <el-empty class="empty" description="暂无数据" v-if="empty"></el-empty>
                        <ul v-if="!empty">
                            <li v-for="(item, index) in resultList" :key="index" @click="toStarLevel(item, documentTitle)">
                                <img :src="baseUrl + item.peopleImg" alt="" @error="imgerrorfun">
                                <div class="title">
                                    <div>{{ item.name }}</div>
                                    <div>{{ item.workUnit }}</div>
                                </div>
                            </li>
                        </ul>
                        <el-pagination @current-change="currentChange"
                          v-if="!empty"
                          background
                          :current-page="page"
                          layout="prev, pager, next, jumper"
                          next-text="下一页"
                          prev-text="上一页"
                          :total="total">
                        </el-pagination>
                        <div style="text-align: center;font-size: 14px;color: #666;margin-top: 10px;">最多显示50条,如需更多,请输入更精准的查询条件</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'integrity_search',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            input: '',
            empty: true,
            menuTabList: [
                {
                    name: '首页',
                    title: '企业诚信官',
                    url: '/integrity'
                },
                {
                    name: '培训动态',
                    title: '培训动态',
                    url: '/integrity_list'
                },
                // {
                //     name: '新闻图片',
                //     title: '新闻图片',
                //     url: '/integrity_list'
                // },
                {
                    name: '活动通知',
                    title: '活动通知',
                    url: '/integrity_list'
                },
                {
                    name: '政策文件',
                    title: '政策文件',
                    url: '/integrity_list'
                },
                {
                    name: '优秀学员',
                    title: '优秀学员',
                    url: '/goodStudents'
                },
                {
                    name: '证书查询',
                    title: '证书查询',
                    url: ''
                },
                {
                    name: '师资介绍',
                    title: '师资介绍',
                    url: '/integrity_search'
                },
                {
                    name: '培训课程',
                    title: '培训课程',
                    url: '/integrity_list'
                },
                {
                    name: '推荐图书',
                    title: '推荐图书',
                    url: '/integrity_list'
                },
            ],
            resultList: [
                // {
                //     title: '北京长友物业管理有限公司北京长友物业管理有限公司北京长友物业管理有限公司',
                //     imgUrl: require('../../assets/img/index/starLevel.png'),
                // },
                // {
                //     title: '北京紫金百合投资有限公司',
                //     imgUrl: require('../../assets/img/index/starLevel.png'),
                // },
                // {
                //     title: '北京华升融智商务咨询有限公司',
                //     imgUrl: require('../../assets/img/index/starLevel2.png'),
                // },
                // {
                //     title: '国民淀粉化学贸易有限公司',
                //     imgUrl: require('../../assets/img/index/starLevel3.png'),
                // },
                // {
                //     title: '北京长友物业管理有限公司北京长友物业管理有限公司北京长友物业管理有限公司',
                //     imgUrl: require('../../assets/img/index/starLevel.png'),
                // },
            ],
            total: 0,
            page: 1,
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        this.searchPlaceholder = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.resultList = []

        window.addEventListener('keydown', this.handkeyCode, true)
    },
    destroyed() {
        window.removeEventListener('keydown', this.handkeyCode, true)
    },
    methods: {
        // 回车搜索
        handkeyCode(e) {
        //    console.log(e);
           if (e.keyCode === 13){
               this.getList()
           }
        },

        // 查询列表
        getList() {
            let _this = this
            _this.resultList = []
            _this.empty = true
            // console.log(this.input);
            let params = {
                param: this.input,
                page: _this.page,
                limit: 12
            }
            if (this.input == '') {
                _this.$message.error('请输入关键词')
            } else {
                api.getListTeacher(params).then(res => {
                    let { data } = res
                    // console.log(data);
                    if (data.status == 200) {
                        _this.resultList = data.data.data
                        _this.total = data.data.total
                        if (_this.total == 0) {
                            _this.empty = true
                        } else {
                            _this.empty = false
                        }
                    } else {
                        
                    }
                })
                .catch(error => {
                //   _this.$toast('网络错误，请检查网络')
                })
            }
        },

        // 分页
        currentChange(val) {
            this.page = val;
            this.getList()
        },

        // 图片错误回调
        imgerrorfun(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/index/person.webp');
            img.onerror = null; //控制不要一直跳动 
        },

        // 前往详情
        toStarLevel(item, title) {
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_detail"
            // });
            let text = title + '详情'

            this.$router.push({
                name: 'integrity_detail',
                query: {
                    documentTitle: text,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + text + '&id=' + item.id + '&isPerson=true', '_blank');
        },

        
        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },
    }
}
</script>

<style lang="less" scoped>
.integrity_search {
    position: relative;
    padding-bottom: 140px;
    .centerTab {
            width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
            margin: 0 auto;
            padding: 0 50px;
            margin-top: 10px;
            .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 20px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
        }
    .main {
        width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
        padding: 15px 50px;
        margin: 0 auto;
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 500px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px 218px;
                .input {
                    display: flex;
                    justify-content: space-between;
                    /deep/ .el-input {
                        width: 90%;

                    }
                    /deep/ .el-button {
                        border-radius: 1px;
                        background-color: #1A68E8;
                        width: 94px;
                    }
                    /deep/ .el-input__inner {
                        height: 48px;
                        line-height: 48px;
                        font-size: 18px;
                        color: #999;
                    }
                    /deep/ .el-input__icon {
                        font-size: 28px;
                        width: 35px;
                        line-height: 50px;
                        color: #999;
                    }
                }
                .result {
                    padding: 20px;
                    background-color: #F2F7FF;
                    margin-top: 15px;
                    ul {
                        overflow: hidden;
                        padding-bottom: 20px;
                        min-height: 300px;
                    }
                    li {
                        float: left;
                        width: 25%;
                        display: flex;
                        justify-content: center;
                        align-items: top;
                        font-size: 16px;
                        color: #666;
                        padding: 0 15px 25px 0;
                        cursor: pointer;
                        img {
                            width: 90px;
                            height: 67px;
                            object-fit: contain;
                        }
                        .title {
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            word-break: break-all;
                            width: 100px;
                            margin-left: 10px;
                        }
                    }
                    li:hover {
                        .title {
                            color: #258AFF;
                        }
                    }
                    /deep/ .el-pagination {
                        display: flex;
                        justify-content: center;
                    }
                    /deep/ .el-pager li {
                        background: #fff;
                        border: 1px solid #ddd;
                        border-radius: 1px;
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        width: 34px;
                    }
                    /deep/ .el-pager li:nth-of-type(n+2) {
                        border-left: none;
                    }
                    /deep/ .btn-next {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-left: none;
                    }
                    /deep/ .btn-prev {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-right: none;
                    }
                    /deep/ .el-pager li:not(.disabled).active {
                        background-color: #1A68E8;
                    }
                }
            }
        }
    }
}
</style>

